var baseStyles = {
raw: "*{box-sizing:border-box}[class^=hcr-]{margin:0;padding:0}[class^=hcr-]:after,[class^=hcr-]:before{box-sizing:border-box}"};

export { baseStyles as default };
